import { Modal, Text } from "@components/ui";
import cn from "clsx";
import { EModalType, ICustomer } from "@middleware/types";
import React from "react";
import { setToStorage } from "@middleware/helpers/global/sessions";
import {
  REFERRAL_FORM_SUBMITTED,
  REFERRAL_MODAL,
  UTM_POPUP,
} from "@middleware/constants";
import { PrismicRichText } from "@prismicio/react";
import { Content } from "@prismicio/client";
import { useTranslation } from "next-i18next";
import style from "./ReferralModal.module.scss";
import style2 from "../Modals.module.scss";
import Benefits from "./Benefits";
import { TitlePage } from "../../TitlePage/TitlePage";
import { SponsorshipEmail } from "./SponsorshipEmail/SponsorshipEmail";
import Background from "../ModalBackground/Background";

interface Props {
  modalContent?:
    | Content.ReferralPopupDocument
    | Content.ReferralPopupStagingDocument;
  customer: ICustomer;
  isOpen: boolean;
  setIsOpen: (open: boolean) => void;
  mailSubmitted?: () => void;
}
export default function ReferralModal({
  customer,
  modalContent,
  setIsOpen,
  isOpen,
  mailSubmitted,
}: Props) {
  const { t } = useTranslation();

  const handleClosingModal = () => {
    setIsOpen(false);
    setToStorage(REFERRAL_MODAL, "true");
  };
  const afterMailSent = () => {
    setToStorage(REFERRAL_FORM_SUBMITTED, "true");
    handleClosingModal();
    if (mailSubmitted) mailSubmitted();
  };

  return isOpen ? (
    <div className={cn(style.referralModal, style2.globalModal)}>
      <Modal
        onClose={handleClosingModal}
        variant={EModalType.FIXED}
        className={cn(style.modal, style2.modal)}
      >
        <Background modalContent={modalContent} />
        <div className={style.wrapper}>
          <TitlePage className={style.title}>
            <PrismicRichText field={modalContent?.data.title} />
          </TitlePage>
          <Benefits modalContent={modalContent} />
          <SponsorshipEmail
            customer={customer}
            emailLabel=""
            className={style.referralForm}
            submitLabel={t("buttons.sponsor").toString()}
            afterEMailSent={afterMailSent}
            utms={{ utm_campaign: UTM_POPUP }}
            EmailLegalNotice={
              <Text className={style.notice}>
                <PrismicRichText field={modalContent?.data.emailLegalNotice} />
              </Text>
            }
          />
          <div className={style.terms}>
            <PrismicRichText field={modalContent?.data.termsFooter} />
          </div>
        </div>
      </Modal>
    </div>
  ) : null;
}
